import { Theme } from '@mui/material';

export const forDesktop = (theme: Theme) => theme.breakpoints.up('md'); // ≥ 900px
export const forPhone = (theme: Theme) => theme.breakpoints.down('sm'); // < 600px
export const forMobile = (theme: Theme) => theme.breakpoints.down('md'); // < 600px
export const forTablet = (theme: Theme) => theme.breakpoints.between('sm', 'md'); // 600–899px
export const forLaptop = (theme: Theme) => theme.breakpoints.between('sm', 'lg'); // 900–1200px
